/* global Provider */
import React, { Component } from 'react';
import Step from './Step';

export default class VerificationStep extends Component {
    componentDidUpdate(prevProps){
        if (this.props.className !== prevProps.className && this.props.className === 'active'){
            Provider.showModal('Before selecting a target date fund series, the following information should be considered:', this.getModalContent(), 'modal-lg', () => {}, null, this.getModalFooter());
        }
    }

    getModalFooter(){
        return (
            <div style={{ width: '100%' }}>
                <button type="button" className="float-left btn btn-sm btn-secondary" style={{ minWidth: '100px', padding: '4px 10px' }} data-dismiss="modal" onClick={() => {
                    this.props.onVerificationCancelled();
                    Provider.hideModal();   
                }}>Close</button>   
                <button id="verifyNextBtn" type="button" className="float-right btn btn-sm btn-success" style={{ minWidth: '100px', padding: '4px 10px' }} data-dismiss="modal" onClick={() => {
                    this.props.onVerified(true);
                    Provider.hideModal();   
                }}>Next</button>   
            </div>
        );
    }

    getModalContent(){
        return (
            <div> 
                <div>
                    <ul>
                        <li className="text-normal">                    
                            Investment Performance
                        </li>
                        <li className="text-normal">                        
                            Fees and expenses
                        </li>
                        <li className="text-normal">                                               
                            Risks of the fund
                        </li>
                        <li className="text-normal">                                               
                            The prospectuses
                        </li>                        
                    </ul>                    
                    <div className="mt-4">
                        Indicate the commercially available resources that you currently use to evaluate Target Date options:
                        <textarea rows="4" type="text" className="mt-2 form-control" placeholder="List resources..." defaultValue="Target-Date Blueprint" onChange={(event) => {
                            Provider.setResponse('resources', event.target.value.split('\n').join(', '));
                        }}></textarea>
                        <span className="text-small text-muted">*Place each resource on a new line.</span>
                    </div>
                </div>                   
            </div>                
        );
    }

    render() {        
        return <Step className={this.props.className} />;
    }    
}